export interface Contract {
  contractId: string
  integraClientCode: string
  integraContractCode: string
  status: ContractStatus
  metre: ContractMetre
  payment: ContractPayment
  contacts: Contacts
  puf: ContractAddress
  accountHolder: AccountHolder
  arera: ContractArera
  serviceLoanLossProvisions: ServiceLoanLossProvisions
  serviceBankDomiciliation: ServiceBankDomiciliation
  serviceOnlineBill: ServiceOnlineBill
  invoices: IInvoices
  token: string
}

export interface Pagination {
  totalPages: number
  totalElements: number
  pageSize: number
  currentPage: number
}

export interface Invoice {
  id: string
  invoicenumber: string
  issueDate: string
  expirationDate: string
  amount: number
  paidAmount: number
  residualAmount: number
  isPaid: boolean
  deferredPayment: string
  printType: string
  pdfPath: string
}

export interface IInvoices {

}

export interface ServiceOnlineBill {
  enabled: boolean
  email: string
}

export interface ServiceBankDomiciliation {
  enabled: boolean
  iban: string
  abi: string
  cab: string
  bankAccount: string
}

export interface ServiceLoanLossProvisions {
  enabled: boolean
}

export interface ContractArera {
  classification: string
  subtype: string
}

export interface AccountHolder {
  businessName: string
  fiscalCode: string
  vatnumber: string
  address: ContractAddress
}

export interface ContractAddress {
  code: string
  street: string
  streetnumber: string
  city: string
  province: string
  postalCode: string
}

export interface ContractStatus {
  code: string
  description: string
}

export interface Contacts {
  businessName: string
  address: ContractAddress
}

export interface ContractMetre {
  serialnumber: string
  location: string
  diameter: string
  indicesnumber: string,
  consumptions:Consumptions
}



export interface Consumptions {
  pagination: Pagination,
  elements: Consumption
}



export interface Consumption {
  invoicenumber: string,
  consumption: number,
  initialMetreReading: number,
  finalMetreReading: number,
  metreReadingStatus: string,
  startDate: string,
  endDate: string,
}
export interface ContractPayment {
  code: string
  description: string
}

export interface IContractDetailReq {
  contractId: string
}

export const ContractDetailReq = (contractId: string) => {
  return {
    contractDetailReq: {
      contractId: contractId
    }
  }
}
export const InvoicesReq = (nacExclude: boolean) => {
  return {
    InvoicesReq: {
      nacExclude: nacExclude
    }
  }
}
export const ContractsId = (contractIds: Array<string>) => {
  return {
    "contractsId": {
      contractsId: contractIds
    }
  }
}
